/**
 * Do not edit directly
 * Generated on Tue, 19 Aug 2025 07:27:31 GMT
 */

export const backgroundStaticFlat = "hsl(0, 0%, 7%)";
export const backgroundStaticRaised = "hsl(0, 0%, 9%)";
export const backgroundStaticFloating = "hsl(0, 0%, 12%)";
export const backgroundStaticSunken = "hsl(0, 0%, 0%)";
export const backgroundStaticInverse = "hsl(0, 0%, 91%)";
export const backgroundStaticOnColor = "hsl(0, 0%, 7%)";
export const backgroundStaticInverseOnColor = "hsl(0, 0%, 7%)";
export const backgroundInteractivePrimaryDefault = "hsl(0, 0%, 100%)";
export const backgroundInteractivePrimaryHover = "hsl(0, 0%, 91%)";
export const backgroundInteractivePrimaryActive = "hsl(0, 0%, 82%)";
export const backgroundInteractiveSecondaryDefault = "hsl(0, 0%, 16%)";
export const backgroundInteractiveSecondaryHover = "hsl(0, 0%, 25%)";
export const backgroundInteractiveSecondaryActive = "hsl(0, 0%, 35%)";
export const backgroundInteractiveDangerDefault = "hsl(1, 85%, 58%)";
export const backgroundInteractiveDangerHover = "hsl(1, 91%, 66%)";
export const backgroundInteractiveDangerActive = "hsl(1, 95%, 74%)";
export const backgroundInteractiveNeutralSubtleDefault = "hsl(0, 0%, 7%)";
export const backgroundInteractiveNeutralSubtleHover = "hsla(0, 0%, 63%, 0.16)";
export const backgroundInteractiveNeutralSubtleActive = "hsla(0, 0%, 63%, 0.32)";
export const backgroundInteractiveNeutralDefault = "hsl(0, 0%, 16%)";
export const backgroundInteractiveNeutralHover = "hsl(0, 0%, 21%)";
export const backgroundInteractiveNeutralActive = "hsl(0, 0%, 25%)";
export const backgroundInteractiveNeutralBoldDefault = "hsl(0, 0%, 63%)";
export const backgroundInteractiveNeutralBoldActive = "hsl(0, 0%, 82%)";
export const backgroundInteractiveNeutralBoldHover = "hsl(0, 0%, 72%)";
export const backgroundInteractiveSuccessDefault = "hsl(113, 34%, 51%)";
export const backgroundInteractiveSuccessHover = "hsl(116, 37%, 62%)";
export const backgroundInteractiveSuccessActive = "hsl(116, 40%, 73%)";
export const backgroundAlertWarningPrimary = "hsl(39, 100%, 27%)";
export const backgroundAlertWarningSecondary = "hsl(44, 100%, 13%)";
export const backgroundAlertSuccessPrimary = "hsl(119, 48%, 24%)";
export const backgroundAlertSuccessSecondary = "hsl(127, 44%, 15%)";
export const backgroundAlertInfoPrimary = "hsl(217, 79%, 40%)";
export const backgroundAlertInfoSecondary = "hsl(220, 58%, 18%)";
export const backgroundAlertDangerPrimary = "hsl(3, 94%, 35%)";
export const backgroundAlertDangerSecondary = "hsl(11, 100%, 12%)";
export const backgroundAlertBasicPrimary = "hsl(0, 0%, 63%)";
export const backgroundAlertBasicSecondary = "hsl(0, 0%, 16%)";
export const backgroundAccentSecondary = "hsl(241, 100%, 76%)";
export const backgroundAccentPrimary = "hsl(240, 18%, 90%)";
export const backgroundAccentBrand = "hsl(241, 75%, 48%)";
export const backgroundAccentInfo = "hsl(215, 95%, 61%)";
export const backgroundAccentDanger = "hsl(1, 85%, 58%)";
export const backgroundAccentSuccess = "hsl(113, 34%, 51%)";
export const backgroundAccentWarning = "hsl(39, 95%, 58%)";
export const backgroundAccentGradient = "hsl(240, 17%, 10%)";
export const backgroundDatavizBlue = "hsl(216, 60%, 60%)";
export const backgroundDatavizOrange = "hsl(21, 100%, 73%)";
export const backgroundDatavizGreen = "hsl(184, 68%, 48%)";
export const backgroundDatavizRed = "hsl(356, 100%, 68%)";
export const backgroundDatavizPurple = "hsl(262, 82%, 62%)";
export const backgroundDatavizPink = "hsl(311, 100%, 84%)";
export const backgroundDatavizInfo = "hsl(216, 90%, 56%)";
export const backgroundDatavizSuccess = "hsl(111, 42%, 42%)";
export const backgroundDatavizWarning = "hsl(36, 91%, 49%)";
export const backgroundDatavizDanger = "hsl(1, 85%, 58%)";
export const backgroundDisabled = "hsl(0, 0%, 25%)";
export const backgroundBrand = "hsl(0, 0%, 100%)";
export const backgroundBackdrop = "hsla(240, 18%, 9%, 0.64)";
export const textStaticPrimary = "hsl(0, 0%, 91%)";
export const textStaticSecondary = "hsl(0, 0%, 82%)";
export const textStaticTertiary = "hsl(0, 0%, 63%)";
export const textStaticInverse = "hsl(0, 0%, 7%)";
export const textStaticOnColor = "hsl(0, 0%, 100%)";
export const textInteractivePrimaryDefault = "hsl(0, 0%, 91%)";
export const textInteractivePrimaryHover = "hsl(0, 0%, 82%)";
export const textInteractivePrimaryActive = "hsl(0, 0%, 72%)";
export const textInteractiveSecondaryDefault = "hsl(0, 0%, 63%)";
export const textInteractiveSecondaryHover = "hsl(0, 0%, 72%)";
export const textInteractiveSecondaryActive = "hsl(0, 0%, 82%)";
export const textAlertDanger = "hsl(1, 95%, 74%)";
export const textAlertWarning = "hsl(41, 97%, 69%)";
export const textAlertSuccess = "hsl(116, 37%, 62%)";
export const textAlertInfo = "hsl(214, 100%, 76%)";
export const textAlertBasic = "hsl(0, 0%, 91%)";
export const textDisabled = "hsl(0, 0%, 63%)";
export const borderStaticPrimary = "hsl(0, 0%, 25%)";
export const borderStaticSecondary = "hsl(0, 0%, 25%)";
export const borderStaticTertiary = "hsl(0, 0%, 44%)";
export const borderStaticInverse = "hsl(0, 0%, 16%)";
export const borderStaticOnColor = "hsl(0, 0%, 100%)";
export const borderInteractivePrimaryDefault = "hsl(0, 0%, 91%)";
export const borderInteractivePrimaryHover = "hsl(0, 0%, 82%)";
export const borderInteractivePrimaryActive = "hsl(0, 0%, 72%)";
export const borderInteractiveSecondaryDefault = "hsl(0, 0%, 35%)";
export const borderInteractiveSecondaryHover = "hsl(0, 0%, 44%)";
export const borderInteractiveSecondaryActive = "hsl(0, 0%, 52%)";
export const borderInteractiveBoldDefault = "hsl(0, 0%, 63%)";
export const borderInteractiveBoldHover = "hsl(0, 0%, 72%)";
export const borderInteractiveBoldActive = "hsl(0, 0%, 82%)";
export const borderInteractiveFocus = "hsl(0, 0%, 52%)";
export const borderInteractiveInputDefault = "hsl(0, 0%, 44%)";
export const borderInteractiveInputHover = "hsl(0, 0%, 52%)";
export const borderInteractiveInputActive = "hsl(0, 0%, 63%)";
export const borderAlertWarning = "hsl(39, 100%, 27%)";
export const borderAlertSuccess = "hsl(123, 46%, 19%)";
export const borderAlertInfo = "hsl(218, 73%, 36%)";
export const borderAlertDanger = "hsl(7, 98%, 25%)";
export const borderAlertBasic = "hsl(0, 0%, 9%)";
export const borderAccent = "hsl(0, 0%, 72%)";
export const borderDisabled = "hsl(0, 0%, 25%)";
export const borderBrand = "hsl(240, 17%, 80%)";
export const fontSizeBase = 16;
export const fontSizeRatio = 1.12;
export const fontSize50 = 13;
export const fontSize75 = 14;
export const fontSize100 = 16;
export const fontSize200 = 18;
export const fontSize300 = 20;
export const fontSize400 = 22;
export const fontSize500 = 25;
export const fontSize600 = 28;
export const fontSize700 = 32;
export const fontSize800 = 35;
export const fontSize900 = 40;
export const visualAssetsNeutralSubtle = "hsl(240, 15%, 23%)";
export const visualAssetsNeutralSubtle0 = "hsla(240, 15%, 23%, 0)";
export const visualAssetsNeutralBold = "hsl(0, 0%, 100%)";
export const visualAssetsNeutralBold0 = "hsla(0, 0%, 100%, 0)";
export const visualAssetsSemanticDanger = "hsl(1, 91%, 66%)";
export const visualAssetsSemanticWarning = "hsl(39, 95%, 58%)";
export const visualAssetsSemanticSuccess = "hsl(113, 34%, 51%)";
export const visualAssetsSemanticInfo = "hsl(215, 99%, 67%)";
export const visualAssetsAccent = "hsl(242, 89%, 83%)";
export const paletteBrandIndigo0 = "hsl(241, 100%, 10%)";
export const paletteBrandIndigo25 = "hsl(241, 100%, 14%)";
export const paletteBrandIndigo50 = "hsl(241, 96%, 18%)";
export const paletteBrandIndigo100 = "hsl(241, 91%, 26%)";
export const paletteBrandIndigo150 = "hsl(241, 86%, 34%)";
export const paletteBrandIndigo200 = "hsl(241, 83%, 41%)";
export const paletteBrandIndigo300 = "hsl(241, 75%, 48%)";
export const paletteBrandIndigo400 = "hsl(241, 77%, 54%)";
export const paletteBrandIndigo500 = "hsl(241, 82%, 58%)";
export const paletteBrandIndigo600 = "hsl(241, 87%, 67%)";
export const paletteBrandIndigo700 = "hsl(241, 100%, 76%)";
export const paletteBrandIndigo800 = "hsl(242, 89%, 83%)";
export const paletteBrandIndigo900 = "hsl(242, 90%, 92%)";
export const paletteBrandIndigo1000 = "hsl(240, 100%, 98%)";
export const paletteBrandNight0 = "hsl(240, 18%, 9%)";
export const paletteBrandNight25 = "hsl(240, 17%, 10%)";
export const paletteBrandNight50 = "hsl(240, 16%, 12%)";
export const paletteBrandNight100 = "hsl(240, 15%, 16%)";
export const paletteBrandNight150 = "hsl(240, 15%, 23%)";
export const paletteBrandNight200 = "hsl(240, 14%, 30%)";
export const paletteBrandNight300 = "hsl(240, 14%, 38%)";
export const paletteBrandNight400 = "hsl(240, 13%, 45%)";
export const paletteBrandNight500 = "hsl(240, 13%, 53%)";
export const paletteBrandNight600 = "hsl(240, 16%, 61%)";
export const paletteBrandNight700 = "hsl(240, 16%, 71%)";
export const paletteBrandNight800 = "hsl(240, 17%, 80%)";
export const paletteBrandNight900 = "hsl(240, 18%, 90%)";
export const paletteBrandNight1000 = "hsl(0, 0%, 100%)";
export const paletteBrandNight064 = "hsla(240, 18%, 9%, 0.64)";
export const paletteBrandNight10008 = "hsla(0, 0%, 100%, 0.08)";
export const paletteBrandNight100012 = "hsla(0, 0%, 100%, 0.12)";
export const paletteBrandNight100016 = "hsla(0, 0%, 100%, 0.16)";
export const paletteBrandCoral0 = "hsl(356, 100%, 10%)";
export const paletteBrandCoral25 = "hsl(356, 100%, 14%)";
export const paletteBrandCoral50 = "hsl(356, 100%, 17%)";
export const paletteBrandCoral100 = "hsl(356, 100%, 25%)";
export const paletteBrandCoral150 = "hsl(356, 100%, 31%)";
export const paletteBrandCoral200 = "hsl(356, 100%, 37%)";
export const paletteBrandCoral300 = "hsl(356, 100%, 42%)";
export const paletteBrandCoral400 = "hsl(356, 100%, 45%)";
export const paletteBrandCoral500 = "hsl(356, 100%, 46%)";
export const paletteBrandCoral600 = "hsl(356, 100%, 47%)";
export const paletteBrandCoral700 = "hsl(356, 100%, 48%)";
export const paletteBrandCoral800 = "hsl(356, 94%, 68%)";
export const paletteBrandCoral900 = "hsl(356, 95%, 85%)";
export const paletteBrandCoral1000 = "hsl(355, 100%, 96%)";
export const paletteBrandGrey0 = "hsl(0, 0%, 7%)";
export const paletteBrandGrey25 = "hsl(0, 0%, 9%)";
export const paletteBrandGrey50 = "hsl(0, 0%, 12%)";
export const paletteBrandGrey100 = "hsl(0, 0%, 16%)";
export const paletteBrandGrey150 = "hsl(0, 0%, 21%)";
export const paletteBrandGrey200 = "hsl(0, 0%, 25%)";
export const paletteBrandGrey300 = "hsl(0, 0%, 35%)";
export const paletteBrandGrey400 = "hsl(0, 0%, 44%)";
export const paletteBrandGrey500 = "hsl(0, 0%, 52%)";
export const paletteBrandGrey600 = "hsl(0, 0%, 63%)";
export const paletteBrandGrey700 = "hsl(0, 0%, 72%)";
export const paletteBrandGrey800 = "hsl(0, 0%, 82%)";
export const paletteBrandGrey900 = "hsl(0, 0%, 91%)";
export const paletteBrandGrey1000 = "hsl(0, 0%, 100%)";
export const paletteSemanticBlue0 = "hsl(220, 55%, 13%)";
export const paletteSemanticBlue25 = "hsl(220, 58%, 18%)";
export const paletteSemanticBlue50 = "hsl(218, 63%, 22%)";
export const paletteSemanticBlue100 = "hsl(218, 68%, 31%)";
export const paletteSemanticBlue150 = "hsl(218, 73%, 36%)";
export const paletteSemanticBlue200 = "hsl(217, 79%, 40%)";
export const paletteSemanticBlue300 = "hsl(216, 84%, 46%)";
export const paletteSemanticBlue400 = "hsl(216, 82%, 52%)";
export const paletteSemanticBlue500 = "hsl(216, 90%, 56%)";
export const paletteSemanticBlue600 = "hsl(215, 95%, 61%)";
export const paletteSemanticBlue700 = "hsl(215, 99%, 67%)";
export const paletteSemanticBlue800 = "hsl(214, 100%, 76%)";
export const paletteSemanticBlue900 = "hsl(213, 100%, 88%)";
export const paletteSemanticBlue1000 = "hsl(200, 100%, 99%)";
export const paletteSemanticOrange0 = "hsl(48, 100%, 3%)";
export const paletteSemanticOrange25 = "hsl(47, 100%, 8%)";
export const paletteSemanticOrange50 = "hsl(44, 100%, 13%)";
export const paletteSemanticOrange100 = "hsl(42, 100%, 22%)";
export const paletteSemanticOrange150 = "hsl(39, 100%, 27%)";
export const paletteSemanticOrange200 = "hsl(36, 100%, 33%)";
export const paletteSemanticOrange300 = "hsl(34, 100%, 40%)";
export const paletteSemanticOrange400 = "hsl(35, 97%, 45%)";
export const paletteSemanticOrange500 = "hsl(36, 91%, 49%)";
export const paletteSemanticOrange600 = "hsl(38, 93%, 53%)";
export const paletteSemanticOrange700 = "hsl(39, 95%, 58%)";
export const paletteSemanticOrange800 = "hsl(41, 97%, 69%)";
export const paletteSemanticOrange900 = "hsl(42, 95%, 85%)";
export const paletteSemanticOrange1000 = "hsl(60, 25%, 98%)";
export const paletteSemanticGreen0 = "hsl(130, 44%, 14%)";
export const paletteSemanticGreen25 = "hsl(127, 44%, 15%)";
export const paletteSemanticGreen50 = "hsl(125, 45%, 16%)";
export const paletteSemanticGreen100 = "hsl(123, 46%, 19%)";
export const paletteSemanticGreen150 = "hsl(120, 48%, 22%)";
export const paletteSemanticGreen200 = "hsl(119, 48%, 24%)";
export const paletteSemanticGreen300 = "hsl(116, 47%, 30%)";
export const paletteSemanticGreen400 = "hsl(113, 45%, 36%)";
export const paletteSemanticGreen500 = "hsl(111, 42%, 42%)";
export const paletteSemanticGreen600 = "hsl(113, 34%, 51%)";
export const paletteSemanticGreen700 = "hsl(116, 37%, 62%)";
export const paletteSemanticGreen800 = "hsl(116, 40%, 73%)";
export const paletteSemanticGreen900 = "hsl(114, 43%, 86%)";
export const paletteSemanticGreen1000 = "hsl(90, 100%, 100%)";
export const paletteSemanticRed0 = "hsl(13, 100%, 7%)";
export const paletteSemanticRed25 = "hsl(11, 100%, 12%)";
export const paletteSemanticRed50 = "hsl(9, 100%, 16%)";
export const paletteSemanticRed100 = "hsl(7, 98%, 25%)";
export const paletteSemanticRed150 = "hsl(4, 96%, 30%)";
export const paletteSemanticRed200 = "hsl(3, 94%, 35%)";
export const paletteSemanticRed300 = "hsl(0, 86%, 44%)";
export const paletteSemanticRed400 = "hsl(1, 78%, 51%)";
export const paletteSemanticRed500 = "hsl(1, 85%, 58%)";
export const paletteSemanticRed600 = "hsl(1, 91%, 66%)";
export const paletteSemanticRed700 = "hsl(1, 95%, 74%)";
export const paletteSemanticRed800 = "hsl(1, 98%, 83%)";
export const paletteSemanticRed900 = "hsl(1, 100%, 92%)";
export const paletteSemanticRed1000 = "hsl(0, 100%, 99%)";
export const paletteDatavizBlue = "hsl(216, 60%, 60%)";
export const paletteDatavizOrange = "hsl(21, 100%, 73%)";
export const paletteDatavizGreen = "hsl(184, 68%, 48%)";
export const paletteDatavizRed = "hsl(356, 100%, 68%)";
export const paletteDatavizPink = "hsl(311, 100%, 84%)";
export const paletteDatavizPurple = "hsl(262, 82%, 62%)";
export const paletteBasicsBlack = "hsl(0, 0%, 0%)";
export const paletteBasicsWhite = "hsl(0, 0%, 100%)";
export const paletteBasicsWhite64 = "hsla(0, 0%, 100%, 0.64)";
export const legacyTagBackgroundBasicBold = "hsl(240, 14%, 30%)";
export const legacyTagBackgroundPrimary = "hsl(241, 91%, 26%)";
export const legacyTagBackgroundDenim = "hsl(212, 77%, 31%)";
export const legacyTagBackgroundLime = "hsl(123, 71%, 20%)";
export const legacyTagBackgroundMustard = "hsl(38, 91%, 45%)";
export const legacyTagBackgroundLavender = "hsl(252, 42%, 41%)";
export const legacyTagBackgroundRuby = "hsl(354, 76%, 42%)";
export const legacyTagBackgroundTangerine = "hsl(15, 72%, 50%)";
export const legacyTagTextBasicBold = "hsl(240, 17%, 80%)";
export const legacyTagTextPrimary = "hsl(242, 89%, 83%)";
export const legacyTagTextDenim = "hsl(206, 47%, 93%)";
export const legacyTagTextLime = "hsl(125, 30%, 92%)";
export const legacyTagTextMustard = "hsl(0, 0%, 100%)";
export const legacyTagTextLavender = "hsl(258, 38%, 95%)";
export const legacyTagTextRuby = "hsl(350, 64%, 95%)";
export const legacyTagTextTangerine = "hsl(0, 0%, 100%)";
export const legacyTagBorderBasicBold = "hsl(240, 16%, 61%)";
export const legacyTagBorderPrimary = "hsl(241, 87%, 67%)";
export const legacyTagBorderDenim = "hsl(205, 47%, 52%)";
export const legacyTagBorderLime = "hsl(125, 35%, 45%)";
export const legacyTagBorderMustard = "hsl(45, 83%, 59%)";
export const legacyTagBorderLavender = "hsl(255, 37%, 64%)";
export const legacyTagBorderRuby = "hsl(350, 65%, 61%)";
export const legacyTagBorderTangerine = "hsl(20, 79%, 73%)";
export const legacyDatavizDenim50 = "hsl(212, 77%, 31%)";
export const legacyDatavizDenim100 = "hsl(209, 68%, 36%)";
export const legacyDatavizDenim200 = "hsl(207, 64%, 39%)";
export const legacyDatavizDenim300 = "hsl(206, 61%, 42%)";
export const legacyDatavizDenim400 = "hsl(205, 59%, 44%)";
export const legacyDatavizDenim500 = "hsl(205, 47%, 52%)";
export const legacyDatavizDenim600 = "hsl(205, 46%, 61%)";
export const legacyDatavizDenim700 = "hsl(205, 46%, 72%)";
export const legacyDatavizDenim800 = "hsl(206, 47%, 83%)";
export const legacyDatavizDenim900 = "hsl(206, 47%, 93%)";
export const legacyDatavizLavender50 = "hsl(252, 42%, 41%)";
export const legacyDatavizLavender100 = "hsl(254, 36%, 47%)";
export const legacyDatavizLavender200 = "hsl(254, 33%, 51%)";
export const legacyDatavizLavender300 = "hsl(255, 35%, 54%)";
export const legacyDatavizLavender400 = "hsl(255, 37%, 57%)";
export const legacyDatavizLavender500 = "hsl(255, 37%, 64%)";
export const legacyDatavizLavender600 = "hsl(255, 37%, 70%)";
export const legacyDatavizLavender700 = "hsl(255, 37%, 79%)";
export const legacyDatavizLavender800 = "hsl(255, 36%, 87%)";
export const legacyDatavizLavender900 = "hsl(258, 38%, 95%)";
export const legacyDatavizLime50 = "hsl(123, 71%, 20%)";
export const legacyDatavizLime100 = "hsl(124, 62%, 26%)";
export const legacyDatavizLime200 = "hsl(125, 58%, 29%)";
export const legacyDatavizLime300 = "hsl(125, 55%, 32%)";
export const legacyDatavizLime400 = "hsl(125, 53%, 35%)";
export const legacyDatavizLime500 = "hsl(125, 35%, 45%)";
export const legacyDatavizLime600 = "hsl(126, 28%, 54%)";
export const legacyDatavizLime700 = "hsl(125, 28%, 67%)";
export const legacyDatavizLime800 = "hsl(126, 28%, 80%)";
export const legacyDatavizLime900 = "hsl(125, 30%, 92%)";
export const legacyDatavizMustard50 = "hsl(38, 91%, 45%)";
export const legacyDatavizMustard100 = "hsl(41, 85%, 48%)";
export const legacyDatavizMustard200 = "hsl(42, 82%, 49%)";
export const legacyDatavizMustard300 = "hsl(44, 81%, 51%)";
export const legacyDatavizMustard400 = "hsl(45, 83%, 52%)";
export const legacyDatavizMustard500 = "hsl(45, 83%, 59%)";
export const legacyDatavizMustard600 = "hsl(45, 83%, 66%)";
export const legacyDatavizMustard700 = "hsl(45, 84%, 76%)";
export const legacyDatavizMustard800 = "hsl(44, 84%, 86%)";
export const legacyDatavizMustard900 = "hsl(45, 80%, 94%)";
export const legacyDatavizTangerine50 = "hsl(15, 72%, 50%)";
export const legacyDatavizTangerine100 = "hsl(17, 74%, 54%)";
export const legacyDatavizTangerine200 = "hsl(18, 76%, 57%)";
export const legacyDatavizTangerine300 = "hsl(19, 77%, 59%)";
export const legacyDatavizTangerine400 = "hsl(20, 79%, 61%)";
export const legacyDatavizTangerine500 = "hsl(20, 79%, 73%)";
export const legacyDatavizTangerine600 = "hsl(20, 79%, 73%)";
export const legacyDatavizTangerine700 = "hsl(20, 80%, 81%)";
export const legacyDatavizTangerine800 = "hsl(19, 80%, 88%)";
export const legacyDatavizTangerine900 = "hsl(20, 75%, 95%)";
export const legacyDatavizRuby50 = "hsl(354, 76%, 42%)";
export const legacyDatavizRuby100 = "hsl(352, 67%, 46%)";
export const legacyDatavizRuby200 = "hsl(351, 63%, 49%)";
export const legacyDatavizRuby300 = "hsl(350, 63%, 52%)";
export const legacyDatavizRuby400 = "hsl(350, 65%, 54%)";
export const legacyDatavizRuby500 = "hsl(350, 65%, 61%)";
export const legacyDatavizRuby600 = "hsl(350, 65%, 68%)";
export const legacyDatavizRuby700 = "hsl(350, 66%, 77%)";
export const legacyDatavizRuby800 = "hsl(351, 66%, 86%)";
export const legacyDatavizRuby900 = "hsl(350, 64%, 95%)";
export const fontFamilyUi = "Inter";
export const fontWeight300 = 300;
export const fontWeight400 = 400;
export const fontWeight500 = 500;
export const fontWeight600 = 600;
export const lineHeight100 = 1;
export const lineHeight200 = 1.3;
export const lineHeight300 = 1.5;
export const letterSpacingCondensed = "-0.2px";
export const letterSpacingDefault = 0;
export const letterSpacingWide = "0.2px";
export const spacing0 = 0;
export const spacing25 = 2;
export const spacing50 = 4;
export const spacing100 = 8;
export const spacing150 = 12;
export const spacing200 = 16;
export const spacing250 = 20;
export const spacing300 = 24;
export const spacing400 = 32;
export const spacing450 = 36;
export const spacing500 = 40;
export const spacing600 = 48;
export const spacing700 = 56;
export const spacing800 = 64;
export const spacing900 = 72;
export const spacing1000 = 80;
export const spacing1200 = 96;
export const borderRadius0 = 0;
export const borderRadius25 = 2;
export const borderRadius50 = 4;
export const borderRadius100 = 8;
export const borderRadius150 = 12;
export const borderRadius200 = 16;
export const borderRadius300 = 24;
export const borderRadiusRound = "50%";
export const borderRadiusBase = 8;
export const spacingBase = 8;
export const borderWidth0 = 0;
export const borderWidth100 = 1;
export const borderWidth200 = 2;
export const borderWidth300 = 3;
export const borderWidth800 = 8;
export const sizingBase = 8;
export const sizing50 = 4;
export const sizing100 = 8;
export const sizing200 = 16;
export const sizing300 = 24;
export const sizing400 = 32;
export const sizing500 = 40;
export const sizing550 = 44;
export const sizing600 = 48;
export const sizing700 = 56;
export const sizing800 = 64;
export const sizing900 = 72;
export const sizing1000 = 80;
export const sizing1200 = 96;
export const sizing1300 = 104;
export const opacity0 = 0;
export const opacity100 = 0.08;
export const opacity150 = 0.12;
export const opacity200 = 0.16;
export const opacity400 = 0.32;
export const opacity600 = 0.48;
export const opacity800 = 0.64;
export const opacity1000 = 1;
export const textDecorationNone = "none";
export const textDecorationUnderline = "underline";
export const highlightLarge = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.3,"fontSize":40,"letterSpacing":"-0.2px"};
export const highlightMedium = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.3,"fontSize":28,"letterSpacing":"-0.2px"};
export const highlightSmall = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.3,"fontSize":20,"letterSpacing":0};
export const titleLarge = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.5,"fontSize":25,"letterSpacing":0};
export const titleLargeStrong = {"fontFamily":"Inter","fontWeight":600,"lineHeight":1.5,"fontSize":25,"letterSpacing":0};
export const titleMedium = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.5,"fontSize":22,"letterSpacing":0};
export const titleMediumStrong = {"fontFamily":"Inter","fontWeight":600,"lineHeight":1.5,"fontSize":22,"letterSpacing":0};
export const titleSmall = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.3,"fontSize":20,"letterSpacing":0};
export const titleSmallStrong = {"fontFamily":"Inter","fontWeight":600,"lineHeight":1.3,"fontSize":20,"letterSpacing":0};
export const bodyLarge = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.5,"fontSize":18,"letterSpacing":0};
export const bodyLargeStrong = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.5,"fontSize":18,"letterSpacing":0};
export const bodyMedium = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.5,"fontSize":16,"letterSpacing":0};
export const bodyMediumStrong = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.5,"fontSize":16,"letterSpacing":0};
export const bodySmall = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.5,"fontSize":14,"letterSpacing":0};
export const bodySmallStrong = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.5,"fontSize":14,"letterSpacing":0};
export const bodyExtraSmall = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1,"fontSize":13,"letterSpacing":"0.2px"};
export const bodyExtraSmallStrong = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1,"fontSize":13,"letterSpacing":"0.2px"};
export const shadow0 = "0px 0px 0px 0px hsl(0, 0%, 0%)";
export const shadow100 = "0px 2px 6px -1px hsla(0, 0%, 100%, 0.08), 0px -1px 4px -2px hsla(0, 0%, 100%, 0.08)";
export const shadow200 = "0px 8px 24px -4px hsla(0, 0%, 100%, 0.08), 0px 6px 12px -6px hsla(0, 0%, 100%, 0.08)";
export const shadow300 = "0px 18px 88px -4px hsla(0, 0%, 100%, 0.12), 0px 12px 28px -6px hsla(0, 0%, 100%, 0.12)";
